import { useEffect, useMemo, useState } from 'react'
import JustificativaCargasParadasHttp from '../../../../services/api/https/deliveries/justificativa-cargas-paradas.http'
import { getMotivoAtraso } from '../../../../services/api/https/registration/motivo-atraso.http'
import { getTps, getUsuarioInfo } from '../../../../services/localstorage/localstorage.service'
import { errorHandler } from '../../../../services/util/error.service'
import { MOTIVO_ATRASO_URL_TYPES } from '../../Cadastros/MotivoAtraso/MotivoAtrasoHook'
import { getPeriodoUltimos30Dias } from '../../../../services/util/date.service'
import { useJustificativaCargasParadasContext } from '../../../../contexts/EntregaContext'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  GET_INITIAL_INFO: 'Adquirindo informações iniciais',
  GET_DELIVERIES: 'Adquirindo entregas para justificativa',
  GET_DELIVERIES_FILTERED: 'Buscando por empresa + Nota Fiscal',
  SAVE_REASON: 'Salvando informações',
  SUCCESS: 'Informações salvas com sucesso',
}

const INITIAL_STATE = {
  globalFilter: '',
  justifyReason: {},
  entregas: [],
  tableVersion: 0,
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
  pathRedirect: '',
  selectedCargaParada: null,
  periodo: getPeriodoUltimos30Dias(),
  companies: [],
  selectedCompany: null,
  identifier: '',
}

export const MENU_ITEMS = ['Datas de Agendamentos']

export default function useJustificativasCargasParadas() {
  const { justificativaCargasParadasContext, setJustificativaCargasParadasContext } =
    useJustificativaCargasParadasContext()

  const [state, setState] = useState({
    ...INITIAL_STATE,
    periodo: justificativaCargasParadasContext.selectedPeriodo || getPeriodoUltimos30Dias(),
    selectedCompany: justificativaCargasParadasContext.selectedCompany || null,
    identifier: justificativaCargasParadasContext.identifier || '',
  })

  useEffect(() => {
    setJustificativaCargasParadasContext(prev => ({
      ...prev,
      selectedPeriodo: state.periodo,
      selectedCompany: state.selectedCompany,
      identifier: state.identifier,
    }))
  }, [state.periodo, state.selectedCompany, state.identifier])

  function buildCompaniesList(entregas) {
    const uniques = []
    entregas.forEach(e => {
      const companyId = e.company_id || e.companyId
      const companyName = e.company_name || e.company

      if (companyId && companyName && !uniques.find(u => u.id === companyId)) {
        uniques.push({ id: companyId, name: companyName })
      }
    })
    return uniques.sort((a, b) => a.name.localeCompare(b.name))
  }

  const localDispatch = useMemo(() => {
    //Helpers

    return {
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      async getVeiculosCarregamento(selectedTp, pInicial, pFinal, company_id, identifier) {
        await JustificativaCargasParadasHttp.getDeliveriesToJustify(
          selectedTp,
          pInicial,
          pFinal,
          company_id,
          identifier,
        )
          .then(entregas =>
            setState(prevState => ({
              ...prevState,
              entregas: entregas,
              tableVersion: prevState.tableVersion + 1,
              companies: buildCompaniesList(entregas),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      async getMotivosAtraso(selectedTp) {
        let tps = selectedTp
        if (!tps) tps = getTps(false).map(tp => tp.id)
        getMotivoAtraso(getUsuarioInfo().id, tps, MOTIVO_ATRASO_URL_TYPES.ENTREGA)
          .then(motivos =>
            setState(prevState => ({
              ...prevState,
              motivosAtraso: [{ id: 0, name: 'Nenhum(a)' }, ...motivos],
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      async saveJustifyToDeliveries(selectedTp, deliveries, justifyReason) {
        const deliveriesEventsId = deliveries.filter(d => d.selected).map(d => d.event_id)
        await JustificativaCargasParadasHttp.saveJustifyToDeliveries(selectedTp, {
          delivery_events_ids: deliveriesEventsId,
          motivo_atraso_id: justifyReason.motivo_atraso_id ? justifyReason.motivo_atraso_id : null,
        })
          .then(deliveries =>
            setState(prevState => ({
              ...prevState,
              entregas: deliveries,
              loadingMessage: LOAD_MESSAGE.SUCCESS,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      //Events
      onGlobalFilterChange(value) {
        setState(prevState => ({ ...prevState, globalFilter: value }))
      },

      onCheckBoxRowClicked(entrega, checked) {
        setState(prevState => {
          const index = prevState.entregas.findIndex(f => f.step_id === entrega.step_id)
          if (index !== -1) {
            prevState.entregas[index].selected = checked
          }
          return { ...prevState }
        })
      },

      onSelecionarTodos(isSelected) {
        setState(prevState => {
          prevState.entregas.forEach(e => (e.selected = isSelected))
          return { ...prevState }
        })
      },

      onInit(selectedTp) {
        if (!selectedTp) setState(prevState => ({ ...prevState, errorMessage: 'Selecione um TP' }))
        else
          setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.GET_INITIAL_INFO }))
      },

      onPesquisar(pInicial, pFinal) {
        setState(prevState => ({
          ...prevState,
          periodo: { dataInicial: pInicial, dataFinal: pFinal },
          loadingMessage: LOAD_MESSAGE.GET_DELIVERIES,
        }))
      },

      onFiltroChange(name, value) {
        setState(prevState => ({ ...prevState, [name]: value }))
      },

      onBuscarFiltrado(selectedCompany, identifier) {
        if (!selectedCompany || !identifier || !identifier.trim()) {
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Selecione a empresa e digite a Nota Fiscal',
          }))
          return
        }

        setState(prevState => ({
          ...prevState,
          selectedCompany,
          identifier,
          loadingMessage: LOAD_MESSAGE.GET_DELIVERIES_FILTERED,
        }))
      },

      onBtnSalvarInfo(justifyReason, entregas) {
        const selectedEntregas = entregas.filter(e => e.selected)
        if (!selectedEntregas.length)
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Selecione pelo menos uma carga para associar a justificativa',
          }))
        else
          setState(prevState => ({
            ...prevState,
            justifyReason: justifyReason,
            loadingMessage: LOAD_MESSAGE.SAVE_REASON,
          }))
      },

      onMenuItemDatasAgendamentosClicked(cargaParada) {
        setState(prevState => ({
          ...prevState,
          selectedCargaParada: cargaParada,
          pathRedirect: '/main/entregas/agendamento-entrega',
        }))
      },

      onThreeDotsClicked(menuItem, cargaParada) {
        switch (menuItem) {
          case 'Datas de Agendamentos':
            this.onMenuItemDatasAgendamentosClicked(cargaParada)
            break
          default:
            break
        }
      },
    }
  }, [])

  return { state, localDispatch }
}
